import { Host, getAssetPath, h } from "@stencil/core";
import * as Feather from "feather-icons";
export class OhIcon {
    constructor() {
        this.name = undefined;
        this.size = 24;
        this.sizeMobile = undefined;
        this.appearance = undefined;
        this.alt = undefined;
        this.customIcon = false;
        this.color = undefined;
    }
    render() {
        const iconClasses = {
            icon: true,
            [`icon--${this.appearance}`]: !!this.appearance,
            'icon--responsive': !!this.sizeMobile,
            [`icon--${this.color}`]: !!this.color,
        };
        if (this.customIcon) {
            return h("img", { src: getAssetPath(`./assets/icons/${this.name}.svg`), class: "iconImg", height: this.size, width: this.size });
        }
        const svg = Feather.icons[this.name]?.toSvg({ width: this.size, height: this.size, alt: this.alt });
        return (h(Host, null, svg && h("div", { class: iconClasses, style: this.sizeMobile && { '--ip-size-mobile': `${this.sizeMobile}px` }, innerHTML: svg })));
    }
    static get is() { return "oh-icon"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["oh-icon.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["oh-icon.css"]
        };
    }
    static get assetsDirs() { return ["assets"]; }
    static get properties() {
        return {
            "name": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "name",
                "reflect": false
            },
            "size": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "size",
                "reflect": false,
                "defaultValue": "24"
            },
            "sizeMobile": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "size-mobile",
                "reflect": false
            },
            "appearance": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "IconAppearance",
                    "resolved": "IconAppearance.GREY_ICON | IconAppearance.SOCIAL_ICON | IconAppearance.UNREAD_ICON",
                    "references": {
                        "IconAppearance": {
                            "location": "import",
                            "path": "./oh-icon.types",
                            "id": "src/components/oh-icon/oh-icon.types.ts::IconAppearance"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "appearance",
                "reflect": false
            },
            "alt": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "alt",
                "reflect": false
            },
            "customIcon": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "custom-icon",
                "reflect": false,
                "defaultValue": "false"
            },
            "color": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "IconColor",
                    "resolved": "IconColor",
                    "references": {
                        "IconColor": {
                            "location": "import",
                            "path": "./oh-icon.types",
                            "id": "src/components/oh-icon/oh-icon.types.ts::IconColor"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "color",
                "reflect": false
            }
        };
    }
}
//# sourceMappingURL=oh-icon.js.map
